import { all, put, takeEvery, select } from 'redux-saga/effects';
import gql from 'graphql-tag';
import { client } from 'src/apollo';


function* handleCreateUserSubmit(action) {

    const CREATE_USER_MUTATION = gql`
        mutation ($data: CreatePortalUserInput!) {
            createPortalUser(data: $data) {
                portalUser {
                    id
                }
            }
        }
    `;

    const { operatorId } = yield select(state => state.session);
    const variables = {
        data: {
            ...action.payload,
            operatorId
        }
    };

    try {
        const { data } = yield client.mutate({
            mutation: CREATE_USER_MUTATION,
            variables
        });
    
    } catch(error) {
        alert(error.message);
    }
}

function* watchCreateUserSubmit() {
    yield takeEvery('CREATE_USER_SUBMIT', handleCreateUserSubmit);
}

export default function* usersManagementRoot() {
    yield all([
        watchCreateUserSubmit()
    ]);
}



// WEBPACK FOOTER //
// ./src/sagas/users-management.js